import { render, staticRenderFns } from "./VendorInformation.vue?vue&type=template&id=7bb94b2d&scoped=true"
import script from "./VendorInformation.vue?vue&type=script&lang=js"
export * from "./VendorInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb94b2d",
  null
  
)

export default component.exports